
export const createAudioWorkletNode = (
  context: AudioContext,
  name: string,
  options?: AudioWorkletNodeOptions
): AudioWorkletNode => {
  return new AudioWorkletNode(context, name, options);
};

export const audioRecorderWorklet = `
class AudioRecorderProcessor extends AudioWorkletProcessor {
  constructor(options) {
    super();
    this.bufferSize = 2048;
    this.buffer = new Int16Array(this.bufferSize);
    this.bufferIndex = 0;

    const processorOptions = options.processorOptions || {};
    this.inputSampleRate = processorOptions.inputSampleRate || 48000;
    this.outputSampleRate = processorOptions.outputSampleRate || 16000;

    this.ratio = this.inputSampleRate / this.outputSampleRate;
    this.nextOutputTime = 0.0;
    this.inputBuffer = [];
  }

  process(inputs, outputs, parameters) {
    const input = inputs[0];
    if (input && input.length > 0) {
      const channelData = input[0];
      
      // Push new samples
      for (let i = 0; i < channelData.length; i++) {
        this.inputBuffer.push(channelData[i]);
      }
      
      // Pull resampled samples
      while (this.inputBuffer.length >= 2) {
        if (this.nextOutputTime < 1.0) {
          const s0 = this.inputBuffer[0];
          const s1 = this.inputBuffer[1];
          const s = s0 + (s1 - s0) * this.nextOutputTime;
          
          // Clamp value between -1 and 1
          const clamped = Math.max(-1, Math.min(1, s));
          
          // Convert to 16-bit PCM
          const pcm = clamped < 0 ? clamped * 0x8000 : clamped * 0x7FFF;
          
          this.buffer[this.bufferIndex++] = pcm;
          
          if (this.bufferIndex >= this.bufferSize) {
            this.port.postMessage(this.buffer.slice());
            this.bufferIndex = 0;
          }
          
          this.nextOutputTime += this.ratio;
        } else {
          // Consume sample
          this.inputBuffer.shift();
          this.nextOutputTime -= 1.0;
        }
      }
    }
    return true;
  }
}

registerProcessor("audio-recorder-processor", AudioRecorderProcessor);
`;

